/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

export const mapViewGoToOptions: __esri.GoToOptions2D = {
  duration : 0,
  easing   : 'ease-out'
};

export const GOOGLE_MAPS_URL = 'https://www.google.com/maps';

/**
 * Defines class name to omit the ClickAwayListener feature
 */
export const OMIT_CLICK_AWAY_LISTENER = 'OMIT_CLICK_AWAY_LISTENER';

/**
 * Raw SVG path for the event triangle icon that can be passed as a simple marker type
 */
export const EVENT_TRIANGLE_PATH = 'M12.0645 7.38782C12.3978 7.58027 12.3978 8.06139 12.0645 8.25384L1.82832 14.1637C1.47874 14.3655 1.04643 14.0913 1.08005 13.689L1.56319 7.90892C1.56549 7.88139 1.56551 7.85372 1.56324 7.82619L1.07887 1.95142C1.04572 1.54939 1.47782 1.27562 1.82718 1.47733L12.0645 7.38782Z';

/**
 * Defines the Icons data for History Layer by Asset
 */
export const HISTORY_EVENT_ICON_BY_ASSET = {
  ignOn : {
    color : '#69B246',
    path  : 'M0 8a8 8 0 1 0 16 0a8 8 0 1 0 -16 0'
  },
  ignOff : {
    color : '#E0E0E0',
    path  : 'M0 8a8 8 0 1 0 16 0a8 8 0 1 0 -16 0'
  },
  stop : {
    color : '#FF7A00',
    path  : 'M8 0C3.58172 -3.86257e-07 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 3.86259e-07 8 0ZM11.5624 5.93785C11.8661 5.63419 11.8661 5.14186 11.5624 4.8382C11.2588 4.53454 10.7664 4.53454 10.4628 4.8382L8.20061 7.10035L5.93842 4.83816C5.63476 4.5345 5.14243 4.5345 4.83877 4.83816C4.53511 5.14182 4.53511 5.63415 4.83877 5.93781L7.10096 8.2L4.83877 10.4622C4.53511 10.7658 4.53511 11.2582 4.83877 11.5618C5.14243 11.8655 5.63476 11.8655 5.93842 11.5618L8.20061 9.29965L10.4628 11.5618C10.7664 11.8655 11.2588 11.8655 11.5624 11.5618C11.8661 11.2581 11.8661 10.7658 11.5624 10.4622L9.30026 8.2L11.5624 5.93785Z'
  },
  battLow : {
    color : '#333333',
    path  : 'M5.57576 9.57576H4V4.84848H5.57576V9.57576ZM5.57576 12.8485H4V11.2727H5.57576V12.8485ZM8.60606 1.57576H7.27273V0H2.42424V1.57576H1.09091C0.484848 1.57576 0 2.06061 0 2.66667V14.9091C0 15.5152 0.484848 16 1.09091 16H8.48485C9.09091 16 9.57576 15.5152 9.57576 14.9091V2.66667C9.57576 2.06061 9.09091 1.57576 8.60606 1.57576Z'
  },
  exception : {
    color : '#F5D518',
    path  : 'M12.29 12.66L12.29 8.61L13.62 8.61L13.71 12.66L12.29 12.66ZM13.62 13.98L13.62 15.3L12.29 15.3L12.29 13.98L13.62 13.98ZM10.39 5.88L6.88 9.46L6.88 14.54L10.39 18.13L15.52 18.13L19.13 14.54L19.13 9.46L15.52 5.88L10.39 5.88Z'
  },
  harshEvent : {
    color : '#E2231A',
    path  : 'M8 0C3.58172 -3.86257e-07 3.86258e-07 3.58172 0 8C-3.86258e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 3.86259e-07 8 0ZM3.79946 5.19971L13.0002 8.00049L3.79946 10.7997L5.00024 8.00049L3.79946 5.19971Z'
  },
  inputEvent : {
    color : '#C629DD',
    path  : 'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.23713 3.34374C5.59957 3.14322 6.05594 3.27449 6.25646 3.63693C6.45698 3.99937 6.32571 4.45574 5.96326 4.65626C5.34751 4.99692 4.83903 5.48691 4.48674 6.07407C4.13457 6.66103 3.9502 7.32532 3.9502 8C3.9502 8.67469 4.13457 9.33902 4.48674 9.92597C4.83902 10.5131 5.34749 11.0031 5.96326 11.3437C6.32571 11.5443 6.45698 12.0006 6.25646 12.3631C6.05594 12.7255 5.59957 12.8568 5.23713 12.6563C4.39452 12.1901 3.69108 11.5154 3.20049 10.6977C2.70979 9.87985 2.4502 8.94913 2.4502 8C2.4502 7.05086 2.70979 6.12018 3.20049 5.30234C3.69107 4.48469 4.39451 3.80991 5.23713 3.34374ZM10.7631 3.34374C10.4006 3.14322 9.94425 3.27449 9.74374 3.63693C9.54322 3.99937 9.67449 4.45574 10.0369 4.65626C10.6527 4.99692 11.1612 5.48691 11.5135 6.07407C11.8656 6.66103 12.05 7.32532 12.05 8C12.05 8.67469 11.8656 9.33902 11.5135 9.92597C11.1612 10.5131 10.6527 11.0031 10.0369 11.3437C9.67449 11.5443 9.54322 12.0006 9.74374 12.3631C9.94425 12.7255 10.4006 12.8568 10.7631 12.6563C11.6057 12.1901 12.3091 11.5154 12.7997 10.6977C13.2904 9.87985 13.55 8.94913 13.55 8C13.55 7.05086 13.2904 6.12018 12.7997 5.30234C12.3091 4.48469 11.6057 3.80991 10.7631 3.34374ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z'
  },
  direction : {
    color : '#02ABCA',
    path  : EVENT_TRIANGLE_PATH
  }
};

/**
 * Defines the Fields of History Layer
 */
export const HISTORY_FIELDS = [
  {name: 'OBJECTID', type: 'oid', alias: 'OBJECTID'},
  {name: 'id', type: 'integer', alias: 'id'},
  {name: 'rendererField', type: 'string', alias: 'rendererField'},
  {name: 'deviceObjectId', type: 'oid', alias: 'deviceObjectId'},
  {name: 'messageUuid', type: 'string', alias: 'messageUuid'},
  {name: 'deviceId', type: 'integer', alias: 'deviceId'},
  {name: 'deviceEsn', type: 'string', alias: 'deviceEsn'},
  {name: 'assetName', type: 'string', alias: 'assetName'},
  {name: 'assetId', type: 'integer', alias: 'assetId'},
  {name: 'eventTime', type: 'date', alias: 'eventTime'},
  {name: 'eventType', type: 'string', alias: 'eventType'},
  {name: 'latitude', type: 'double', alias: 'latitude'},
  {name: 'longitude', type: 'double', alias: 'longitude'},
  {name: 'altitude', type: 'integer', alias: 'altitude'},
  {name: 'heading', type: 'small-integer', alias: 'heading'},
  {name: 'bearing', type: 'double', alias: 'bearing'},
  {name: 'gpsSpeed', type: 'small-integer', alias: 'gps_speed'},
  {name: 'gpsOdometer', type: 'double', alias: 'gpsOdometer'},
  {name: 'gpsValidity', type: 'string', alias: 'gpsValidity'},
  {name: 'hdop', type: 'single', alias: 'hdop'},
  {name: 'satellites', type: 'small-integer', alias: 'satellites'},
  {name: 'rssi', type: 'small-integer', alias: 'rssi'},
  {name: 'street', type: 'string', alias: 'street'},
  {name: 'city', type: 'string', alias: 'city'},
  {name: 'state', type: 'string', alias: 'state'},
  {name: 'postalCode', type: 'string', alias: 'county'},
  {name: 'country', type: 'string', alias: 'country'},
  {name: 'county', type: 'string', alias: 'county'},
  {name: 'crossStreet', type: 'string', alias: 'crossStreet'},
  {name: 'Shape', type: 'geometry', alias: 'Shape'},
  {name: 'accountId', type: 'integer', alias: 'accountId'},
  {name: 'accountName', type: 'string', alias: 'accountName'},
  {name: 'eventCode', type: 'small-integer', alias: 'eventCode'},
  {name: 'deviceMessageSequenceNumber', type: 'integer', alias: 'deviceMessageSequenceNumber'},
  {name: 'postedSpeedLimit', type: 'small-integer', alias: 'postedSpeedLimit'},
  {name: 'postedSpeedLimitUnits', type: 'string', alias: 'postedSpeedLimitUnits'},
  {name: 'ignition', type: 'string', alias: 'ignition'},
  {name: 'input1', type: 'string', alias: 'input1'},
  {name: 'input2', type: 'string', alias: 'input2'},
  {name: 'input3', type: 'string', alias: 'input3'},
  {name: 'input4', type: 'string', alias: 'input4'},
  {name: 'input5', type: 'string', alias: 'input5'},
  {name: 'input6', type: 'string', alias: 'input6'},
  {name: 'input7', type: 'string', alias: 'input7'},
  {name: 'inputBitmap', type: 'string', alias: 'inputBitmap↵'},
  {name: 'systemOfUnits', type: 'string', alias: 'systemOfUnits'},
  {name: 'commStateAvailable', type: 'string', alias: 'commStateAvailable'},
  {name: 'commStateConnected', type: 'string', alias: 'commStateConnected'},
  {name: 'commStateDataService', type: 'string', alias: 'commStateDataService'},
  {name: 'commStateNetworkService', type: 'string', alias: 'commStateNetworkService'},
  {name: 'commStateRoaming', type: 'string', alias: 'commStateRoaming'},
  {name: 'commStateThreeGNetwork', type: 'string', alias: 'commStateThreeGNetwork'},
  {name: 'commStateVoiceCallActive', type: 'string', alias: 'commStateVoiceCallActive'},
  {name: 'gpsFixStatusStatusPredicted', type: 'string', alias: 'gpsFixStatusStatusPredicted'},
  {name: 'gpsFixStatusDiffCorrected', type: 'string', alias: 'gpsFixStatusDiffCorrected'},
  {name: 'gpsFixStatusLastKnown', type: 'string', alias: 'gpsFixStatusLastKnown'},
  {name: 'gpsFixStatusInvalidFix', type: 'string', alias: 'gpsFixStatusInvalidFix'},
  {name: 'gpsFixStatusTwoDFix', type: 'string', alias: 'gpsFixStatusTwoDFix'},
  {name: 'gpsFixStatusHistoric', type: 'string', alias: 'gpsFixStatusHistoric'},
  {name: 'gpsFixStatusInvalidTime', type: 'string', alias: 'gpsFixStatusInvalidTime'},
  {name: 'assetType', type: 'string', alias: 'assetType'},
  {name: 'utilizationState', type: 'string', alias: 'utilizationState'},
  {name: 'dataPumpPullTime', type: 'date', alias: 'dataPumpPullTime'},
  {name: 'dbWriteTime', type: 'date', alias: 'dbWriteTime'},
  {name: 'engineHours', type: 'integer', alias: 'engineHours'},
  {name: 'idleHours', type: 'integer', alias: 'idleHours'},
  {name: 'vbSpeed', type: 'integer', alias: 'vsSpeed'},
  {name: 'vbOdometer', type: 'double', alias: 'vsOdometer'},
  {name: 'vbEngineHours', type: 'double', alias: 'vsEngineHours'},
  {name: 'assetCategory', type: 'string', alias: 'assetCategory'},
  {name: 'location', type: 'string', alias: 'location'},
  {name: 'transportTimeStamp', type: 'double', alias: 'transportTimeStamp'},
  {name: 'adcExternalPowerVoltage', type: 'integer', alias: 'adcExternalPowerVoltage'},
  {name: 'adcDeviceBatteryVoltage', type: 'integer', alias: 'adcDeviceBatteryVoltage'},
  {name: 'routeId', type: 'integer', alias: 'routeId'},
  {name: 'routeName', type: 'string', alias: 'routeName'},
  {name: 'operatorIds', type: 'string', alias: 'operatorIds'},
  {name: 'operatorNames', type: 'string', alias: 'operatorNames'},
  {name: 'vbusMilStatus', type: 'string', alias: 'vbusMilStatus'},
  {name: 'jbusProtectLamp', type: 'string', alias: 'jbusProtectLamp'},
  {name: 'jbusAmberWarningLamp', type: 'string', alias: 'jbusAmberWarningLamp'},
  {name: 'jbusRedStopLamp', type: 'string', alias: 'jbusRedStopLamp'},
  {name: 'assetStatus', type: 'string', alias: 'assetStatus'},
  {name: 'accountStatus', type: 'string', alias: 'accountStatus'},
  {name: 'landmarkId', type: 'string', alias: 'landmarkId'},
  {name: 'vbFuelPercent', type: 'integer', alias: 'vbFuelPercent'},
  {name: 'landmark', type: 'string', alias: 'landmark'},
  {name: 'speed', type: 'integer', alias: 'speed'},
  {name: 'odometer', type: 'double', alias: 'odometer'},
  {name: 'engineHour', type: 'double', alias: 'engineHour'},
  {name: 'reportType', type: 'string', alias: 'reportType'},
  {name: 'timeDiffInHours', type: 'double', alias: 'timeDiffInHours'},
  {name: 'symbolType', type: 'string', alias: 'symbolType'},
  {name: 'deviceName', type: 'string', alias: 'deviceName'},
  {name: 'isScDevice', type: 'string', alias: 'isScDevice'},
  {name: 'batteryLevelValue', type: 'string', alias: 'batteryLevelValue'},
  {name: 'temperatureLevelValue', type: 'string', alias: 'temperatureLevelValue'},
  {name: 'temperatureLevelUnits', type: 'string', alias: 'temperatureLevelUnits'},
  {name: 'lightLevelValue', type: 'string', alias: 'lightLevelValue'},
  {name: 'lightLevelUnits', type: 'string', alias: 'lightLevelUnits'},
  {name: 'shockEvent', type: 'string', alias: 'shock'},
  {name: 'tiltEvent', type: 'string', alias: 'tilt'},
  {name: 'tripGroup', type: 'integer', alias: 'tripGroup'},
  {name: 'stationary', type: 'string', alias: 'stationary'},
  {name: 'isShockTiltAllowed', type: 'string', alias: 'isShockTiltAllowed'},
  {name: 'temperatureBreach', type: 'string', alias: 'temperatureBreach'},
  {name: 'tiltBreach', type: 'string', alias: 'tiltBreach'},
  {name: 'lightBreach', type: 'string', alias: 'lightBreach'},
  {name: 'shockBreach', type: 'string', alias: 'shockBreach'},
  {name: 'minTemperatureThreshold', type: 'string', alias: 'minTemperatureThreshold'},
  {name: 'maxTemperatureThreshold', type: 'string', alias: 'maxTemperatureThreshold'},
  {name: 'minLightThreshold', type: 'string', alias: 'minLightThreshold'},
  {name: 'maxLightThreshold', type: 'string', alias: 'maxLightThreshold'},
  {name: 'VideoURL', type: 'string', alias: 'VideoURL'},
  {name: 'isSevereEvent', type: 'string', alias: 'isSevereEvent'}
];

/**
 * This is a mile value that determines how often we should render a 
 * directionality arrow when we are rendering it between 2 points. If we
 * render arrows when the distance between 2 points is less than this value 
 * it's likely to be too cluttered and unhelpful. 
 */
export const MIN_DISTANCE_FOR_DIRECTION_ARROW = 0.05;

// constants used in AHR
export enum SymbolTypes {
  basicInTripEvent = 'basicInTripEvent',
  basicOutsideTripEvent = 'basicOutsideTripEvent',
  startOfTripEvent = 'startOfTripEvent',
  endOfTripEvent = 'endOfTripEvent',
  harshEvent = 'harshEvent',
  nonDirectionalEvent = 'nonDirectionalEvent'
};

/**
 * Defines the unique identifier for the trip assets layer which is used as globally
 * as the layer id.
 */
export const IN_TRIP_NODE_LAYER    = 'IN_TRIP_NODE_LAYER';
export const IN_TRIP_PATH_LAYER    = 'IN_TRIP_PATH_LAYER';
export const BACKGROUND_NODE_LAYER = 'BACKGROUND_NODE_LAYER';
export const BACKGROUND_PATH_LAYER = 'BACKGROUND_PATH_LAYER';
export const END_EVENT_NODE_LAYER  = 'END_EVENT_NODE_LAYER';
export const TRIP_ASSET_LAYER_ID   = 'tripAssets';

// defines the unique identifier for the Traffic Sub Layer - incident
export const TRAFFIC_SUB_LAYER_INCIDENT = 'incident';

// defines the unique identifier for the Traffic Sub Layer - liveTraffic
export const TRAFFIC_SUB_LAYER_LIVE_TRAFFIC = 'liveTraffic';

/**
 * Defines the Fields of SC Device Layer
 */
export const SC_DEVICE_FIELDS = [
  {name: 'OBJECTID', type: 'oid', alias: 'OBJECTID'},
  {name: 'deviceObjectId', type: 'oid', alias: 'deviceObjectId'},
  {name: 'accountId', type: 'double', alias: 'accountId'},
  {name: 'accountName', type: 'string', alias: 'accountName'},
  {name: 'deviceName', type: 'string', alias: 'deviceName'},
  {name: 'assetAlias', type: 'string', alias: 'assetAlias'},
  {name: 'assetId', type: 'double', alias: 'assetId'},
  {name: 'assetName', type: 'string', alias: 'assetName'},
  {name: 'operatorNames', type: 'string', alias: 'operatorNames'},
  {name: 'operatorAlias', type: 'string', alias: 'operatorAlias'},
  {name: 'assetType', type: 'string', alias: 'assetType'},
  {name: 'eventTime', type: 'string', alias: 'eventTime'},
  {name: 'longitude', type: 'double', alias: 'longitude'},
  {name: 'latitude', type: 'double', alias: 'latitude'},
  {name: 'batteryLevelValue', type: 'string', alias: 'batteryLevelValue'},
  {name: 'batteryLevelUnits', type: 'string', alias: 'batteryLevelUnits'},
  {name: 'dbWriteTime', type: 'string', alias: 'dbWriteTime'},
  {name: 'deviceIdValue', type: 'string', alias: 'deviceIdValue'},
  {name: 'isScDevice', type: 'string', alias: 'isScDevice'},
  {name: 'street', type: 'string', alias: 'street'},
  {name: 'city', type: 'string', alias: 'city'},
  {name: 'state', type: 'string', alias: 'state'},
  {name: 'status', type: 'string', alias: 'status'},
  {name: 'deviceId', type: 'integer', alias: 'deviceId'},
  {name: 'deviceEsn', type: 'string', alias: 'deviceEsn'},
  {name: 'assetCategory', type: 'string', alias: 'assetCategory'},
  {name: 'id', type: 'double', alias: 'deviceId'},
  {name: 'gpsValidity', type: 'string', alias: 'gpsValidity'}
];

// Defines the Fields of Asset Layer
export const ASSET_LAYER_FIELDS = [
  {name: 'OBJECTID', type: 'oid', alias: 'OBJECTID'},
  {name: 'assetName', type: 'string', alias: 'assetName'},
  {name: 'assetId', type: 'double', alias: 'assetId'},
  {name: 'eventTime', type: 'double', alias: 'eventTime'},
  {name: 'eventType', type: 'string', alias: 'eventType'},
  {name: 'latitude', type: 'double', alias: 'latitude'},
  {name: 'longitude', type: 'double', alias: 'longitude'},
  {name: 'altitude', type: 'double', alias: 'altitude'},
  {name: 'heading', type: 'double', alias: 'heading'},
  {name: 'gpsSpeed', type: 'double', alias: 'gpsSpeed'},
  {name: 'gpsOdometer', type: 'double', alias: 'gpsOdometer'},
  {name: 'vbSpeed', type: 'double', alias: 'vbSpeed'},
  {name: 'vbOdometer', type: 'double', alias: 'vbOdometer'},
  {name: 'gpsValidity', type: 'string', alias: 'gpsValidity'},
  {name: 'hdop', type: 'double', alias: 'hdop'},
  {name: 'satellites', type: 'integer', alias: 'satellites'},
  {name: 'rssi', type: 'integer', alias: 'rssi'},
  {name: 'street', type: 'string', alias: 'street'},
  {name: 'city', type: 'string', alias: 'city'},
  {name: 'state', type: 'string', alias: 'state'},
  {name: 'postalCode', type: 'string', alias: 'postalCode'},
  {name: 'country', type: 'string', alias: 'country'},
  {name: 'county', type: 'string', alias: 'county'},
  {name: 'crossStreet', type: 'string', alias: 'crossStreet'},
  {name: 'messageUuid', type: 'string', alias: 'messageUuid'},
  {name: 'accountId', type: 'double', alias: 'accountId'},
  {name: 'accountName', type: 'string', alias: 'accountName'},
  {name: 'eventCode', type: 'integer', alias: 'eventCode'},
  {name: 'deviceMessageSequenceNumber', type: 'double', alias: 'deviceMessageSequenceNumber'},
  {name: 'postedSpeedLimit', type: 'integer', alias: 'postedSpeedLimit'},
  {name: 'postedSpeedLimitUnits', type: 'string', alias: 'postedSpeedLimitUnits'},
  {name: 'vbEngineHours', type: 'double', alias: 'vbEngineHours'},
  {name: 'ignition', type: 'string', alias: 'ignition'},
  {name: 'input1', type: 'string', alias: 'input1'},
  {name: 'input2', type: 'string', alias: 'input2'},
  {name: 'input3', type: 'string', alias: 'input3'},
  {name: 'input4', type: 'string', alias: 'input4'},
  {name: 'input5', type: 'string', alias: 'input5'},
  {name: 'input6', type: 'string', alias: 'input6'},
  {name: 'input7', type: 'string', alias: 'input7'},
  {name: 'inputBitmap', type: 'string', alias: 'inputBitmap'},
  {name: 'systemOfUnits', type: 'string', alias: 'systemOfUnits'},
  {name: 'commStateAvailable', type: 'string', alias: 'commStateAvailable'},
  {name: 'commStateConnected', type: 'string', alias: 'commStateConnected'},
  {name: 'commStateDataService', type: 'string', alias: 'commStateDataService'},
  {name: 'commStateNetworkService', type: 'string', alias: 'commStateNetworkService'},
  {name: 'commStateRoaming', type: 'string', alias: 'commStateRoaming'},
  {name: 'commStateThreeGNetwork', type: 'string', alias: 'commStateThreeGNetwork'},
  {name: 'commStateVoiceCallActive', type: 'string', alias: 'commStateVoiceCallActive'},
  {name: 'gpsFixStatusStatusPredicted', type: 'string', alias: 'gpsFixStatusStatusPredicted'},
  {name: 'gpsFixStatusDiffCorrected', type: 'string', alias: 'gpsFixStatusDiffCorrected'},
  {name: 'gpsFixStatusLastKnown', type: 'string', alias: 'gpsFixStatusLastKnown'},
  {name: 'gpsFixStatusInvalidFix', type: 'string', alias: 'gpsFixStatusInvalidFix'},
  {name: 'gpsFixStatusTwoDFix', type: 'string', alias: 'gpsFixStatusTwoDFix'},
  {name: 'gpsFixStatusHistoric', type: 'string', alias: 'gpsFixStatusHistoric'},
  {name: 'gpsFixStatusInvalidTime', type: 'string', alias: 'gpsFixStatusInvalidTime'},
  {name: 'assetType', type: 'string', alias: 'assetType'},
  {name: 'utilizationState', type: 'string', alias: 'utilizationState'},
  {name: 'dataPumpPullTime', type: 'double', alias: 'dataPumpPullTime'},
  {name: 'dbWriteTime', type: 'double', alias: 'dbWriteTime'},
  {name: 'engineHours', type: 'double', alias: 'engineHours'},
  {name: 'idleHours', type: 'double', alias: 'idleHours'},
  {name: 'assetCategory', type: 'string', alias: 'assetCategory'},
  {name: 'location', type: 'string', alias: 'location'},
  {name: 'adcExternalPowerVoltage', type: 'double', alias: 'adcExternalPowerVoltage'},
  {name: 'adcDeviceBatteryVoltage', type: 'double', alias: 'adcDeviceBatteryVoltage'},
  {name: 'routeId', type: 'double', alias: 'routeId'},
  {name: 'routeName', type: 'string', alias: 'routeName'},
  {name: 'operatorIds', type: 'string', alias: 'operatorIds'},
  {name: 'operatorNames', type: 'string', alias: 'operatorNames'},
  {name: 'vbusMilStatus', type: 'string', alias: 'vbusMilStatus'},
  {name: 'jbusProtectLamp', type: 'string', alias: 'jbusProtectLamp'},
  {name: 'jbusAmberWarningLamp', type: 'string', alias: 'jbusAmberWarningLamp'},
  {name: 'jbusRedStopLamp', type: 'string', alias: 'jbusRedStopLamp'},
  {name: 'assetStatus', type: 'string', alias: 'assetStatus'},
  {name: 'accountStatus', type: 'string', alias: 'accountStatus'},
  {name: 'landmarkId', type: 'double', alias: 'landmarkId'},
  {name: 'vbFuelPercent', type: 'double', alias: 'vbFuelPercent'},
  {name: 'landmark', type: 'string', alias: 'landmark'},
  {name: 'speed', type: 'double', alias: 'speed'},
  {name: 'odometer', type: 'double', alias: 'odometer'},
  {name: 'engineHour', type: 'double', alias: 'engineHour'},
  {name: 'stateProvinceCd', type: 'string', alias: 'stateProvinceCd'},
  {name: 'operatorType', type: 'string', alias: 'operatorType'},
  {name: 'operatorCategory', type: 'string', alias: 'operatorCategory'},
  {name: 'operatorAlias', type: 'string', alias: 'operatorAlias'},
  {name: 'assetAlias', type: 'string', alias: 'assetAlias'},
  {name: 'assets', type: 'string', alias: 'assets'},
  {name: 'addressLabel', type: 'string', alias: 'addressLabel'},
  {name: 'fuelType', type: 'string', alias: 'fuelType'},
  {name: 'evVoltage', type: 'double', alias: 'evVoltage'},
  {name: 'evCurrent', type: 'double', alias: 'evCurrent'},
  {name: 'evBatteryPackRemainingCharge', type: 'double', alias: 'evBatteryPackRemainingCharge'},
  {name: 'evRangeRemaining', type: 'double', alias: 'evRangeRemaining'},
  {name: 'evHybridVoltage', type: 'double', alias: 'evHybridVoltage'},
  {name: 'evHybridCurrent', type: 'double', alias: 'evHybridCurrent'},
  {name: 'evDerivedChargingState', type: 'string', alias: 'evDerivedChargingState'},
  {name: 'batteryRemainingPercent', type: 'string', alias: 'batteryRemainingPercent'},
  {name: 'deviceName', type: 'string', alias: 'deviceName'},
  {name: 'id', type: 'double', alias: 'id'},
  {name: 'geometry', type: 'geometry', alias: 'geometry'},
  {name: 'isSciDevice', type: 'string', alias: 'isSciDevice'},
  {name: 'isCvsAsset', type: 'string', alias: 'isCvsAsset'},
  {name: 'utilizationColor', type: 'string', alias: 'utilizationColor'},
  {name: 'deviceEsn', type: 'string', alias: 'deviceEsn'},
  {name: 'gpsValidity', type: 'string', alias: 'gpsValidity'},
  {name: 'batteryLevelValue', type: 'string', alias: 'batteryLevelValue'}
];
